export const locale = {
  lang: 'pt',
  data: {
    BITSO: {
      AWESOME: 'Crie incrível 🙌',
      BITSO: 'Gerenciamento de criptoativos na Bitso',
      BITSO_ACCOUNT_DETAILS: 'Detalhes da conta',
      BITSO_CRYPTO_ASSETS: 'Ativos cripto',
      BITSO_CRYPTO_QUOTES: 'Cotações Cripto',
      BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY: 'A compra foi realizada com sucesso.',
      BITSO_SUCCESS: 'Sucesso',
      BITSO_ERROR: 'Erro',
      BITSO_COMMUNICATION_ERROR: 'Erro de comunicação',
      GET_BALANCE: 'Obter saldo',
      GET_QUOTE: 'Obter cotação',
      CONFIRM_PURCHASE: 'Confirmar compra',
      GET_CUSTOMER_INFORMATION: 'Obter informações do cliente'
    }
  }
}
